import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
	setChecklinkHeaderMenuData,
	setOpenKeyHeaderMenuData,
	setSelectSideMenu,
} from "../../actions/headerMenu/headerMenu";

const UpdateInventoryImport = () => {
	const { t } = useTranslation();
	const [loginType, setLoginType] = useState("");
	const loginDetials = useSelector((state) => state.loginReducer);
	const headerDetials = useSelector((state) => state.headerMenuReducer);
	const [dealerId, setDealerId] = useState(0);
	
	const [isDiamondShow, setIsDiamondShow] = useState(false);
	const [isJewelryShow, setIsJewelryShow] = useState(false);

	useEffect(() => {
		if (loginDetials) {
			if (loginDetials.loginDetials) {
				if (loginDetials.loginDetials.responseData) {
					setLoginType(
						loginDetials.loginDetials.responseData.dealerMemberTypeName
					);
					setDealerId(loginDetials.loginDetials.responseData.dealerId);
				}
			}
		}
	}, [loginDetials]);

	useEffect(() => {
		if (headerDetials.sideMenuTierThreeDetails) {
			for (var i = 0; i < headerDetials.sideMenuTierThreeDetails.length; i++) {
				if (
					headerDetials.sideMenuTierThreeDetails[i].twoTierPageName == "Products" &&
					headerDetials.sideMenuTierThreeDetails[i].threeTierPageName == "Diamond"
				) {
					setIsDiamondShow(true);
				}
				if (
					headerDetials.sideMenuTierThreeDetails[i].twoTierPageName == "Products" &&
					headerDetials.sideMenuTierThreeDetails[i].threeTierPageName == "Jewelry"
				) {
					setIsJewelryShow(true);
				}
			}
		}
	}, [headerDetials]);

	let navigate = useNavigate();
	const dispatch = useDispatch();

	const uploadDiamondFile = () => {
		dispatch(setChecklinkHeaderMenuData("My Catalog"));
		var MenuData = [`${"Import"}`, `${"ImportDiamond"}`];
		dispatch(setOpenKeyHeaderMenuData(MenuData));
		dispatch(setSelectSideMenu(["uploadDiamondFile"]));
		navigate("/uploadDiamondFile");
	};

	const uploadProductFile = () => {
		dispatch(setChecklinkHeaderMenuData("My Catalog"));
		var MenuData = [`${"Import"}`, `${"ImportJewelry"}`];
		dispatch(setOpenKeyHeaderMenuData(MenuData));
		dispatch(setSelectSideMenu(["uploadProductFile"]));
		navigate("/uploadProductFile");
	};

	const uploadHistory = () => {
		dispatch(setChecklinkHeaderMenuData("My Catalog"));
		var MenuData = [`${"Import"}`, `${"ImportJewelry"}`];
		dispatch(setOpenKeyHeaderMenuData(MenuData));
		dispatch(setSelectSideMenu(["uploadHistory"]));
		navigate("/uploadHistory");
	};
	const DiamondUploadHistory = () => {
		dispatch(setChecklinkHeaderMenuData("My Catalog"));
		var MenuData = [`${"Import"}`, `${"ImportDiamond"}`];
		dispatch(setOpenKeyHeaderMenuData(MenuData));
		dispatch(setSelectSideMenu(["diamonduploadHistory"]));
		navigate("/diamonduploadHistory");
	};

	const renderUploadButtons = () => {
		if (isDiamondShow && !isJewelryShow) {
			return (
				<div className="text-center">
					<h4 className="mt-0 mb-3">{t("Import Diamonds")}</h4>
					<button
						className="primary-btn mt-4"
						onClick={uploadDiamondFile}>
						{t("Upload Diamond Data")}
					</button>
				</div>
			);
		}
		
		if (!isDiamondShow && isJewelryShow) {
			return (
				<div className="text-center">
					<h4 className="mt-0 mb-3">{t("Import Jewelry")}</h4>
					<button
						className="primary-btn mt-4"
						onClick={uploadProductFile}>
						{t("Upload Jewelry Data")}
					</button>
				</div>
			);
		}
		
		if (isDiamondShow && isJewelryShow) {
			return (
				<>
					<div className="text-center me-5">
						<h4 className="mt-0 mb-3">{t("Import Diamonds")}</h4>
						<button
							className="primary-btn mt-4"
							onClick={uploadDiamondFile}>
							{t("Upload Diamond Data")}
						</button>
					</div>
					
					<div className="mx-4 d-flex align-items-center">
						<div className="vertical-divider" style={{
							width: '2px',
							height: '120px',
							backgroundColor: '#ddd',
							borderRadius: '1px'
						}}></div>
					</div>
					
					<div className="text-center ms-5">
						<h4 className="mt-0 mb-3">{t("Import Jewelry")}</h4>
						<button
							className="primary-btn mt-4"
							onClick={uploadProductFile}>
							{t("Upload Jewelry Data")}
						</button>
					</div>
				</>
			);
		}
		
		return (
			<div className="text-center">
				<h4 className="mt-0 mb-3">{t("No import permissions available")}</h4>
				<p className="text-muted">{t("Contact your administrator for access")}</p>
			</div>
		);
	};

	return (
		<React.Fragment>
			<div className="import-data-section-sp d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
				<div className="text-center">
					<div className="mb-5">
						<h3 className="mt-0 mb-2">
							{t("Import Your Data")}
						</h3>
						<h4 className="mt-0 mb-4">
							{t("Upload Your Jewelry & Diamonds")}
						</h4>
					</div>
					
					<div className="d-flex align-items-center justify-content-center">
						{renderUploadButtons()}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default UpdateInventoryImport;
